import instance from '@/utils/axios';

/**
 * code获取字典数据
 * @param {*} code
 * @returns
 */
export function dictByCodeServer(code) {
  return instance.get(`baseinfo/getDict?type=${code}`);
}
